module.exports = __webpack_public_path__ + "videos/hero_cn.317aa11.mp4";